module.exports = __webpack_public_path__ + "img/w3w.52604b2c.svg";